export default __webpack_public_path__ + "static/agile-playbook-background-afa969b83c996efaff270ea37ba4b832.png";